import { Check, CalendarDays, MapPin, Users, Ticket } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { scheduleWhen, feeLabel } from "@/lib/journey";

export const ClassStep = ({ c, n, done, isNext, onToggle, onRegister, last }) => (
  <li id={`class-${c.id}`} className="relative scroll-mt-28 pl-14 sm:pl-20" data-testid={`journey-class-${c.id}`}>
    {!last && <span className={`absolute left-[19px] top-12 h-[calc(100%-1rem)] w-0.5 sm:left-[27px] ${done ? "bg-[#1D64B4]" : "bg-slate-200"}`} />}
    <span className={`absolute left-0 top-2 grid h-10 w-10 place-items-center rounded-full text-sm font-bold sm:h-14 sm:w-14 sm:text-base ${done ? "bg-[#1D64B4] text-white" : isNext ? "bg-white text-[#0A3A6B] ring-4 ring-sky-300" : "bg-white text-slate-400 ring-1 ring-slate-200"}`}>
      {done ? <Check className="h-5 w-5" /> : n}
    </span>
    <div className={`rounded-3xl border bg-white p-6 transition-shadow hover:shadow-lg sm:p-7 ${isNext ? "border-sky-300 shadow-md" : "border-slate-200"}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          {isNext && <span className="mb-2 inline-block rounded-full bg-sky-100 px-3 py-0.5 text-xs font-semibold text-[#0A3A6B]" data-testid={`journey-next-badge-${c.id}`}>Your next step</span>}
          <h3 className="text-xl font-bold tracking-tight text-slate-900">{c.title}</h3>
        </div>
        <label className="flex cursor-pointer items-center gap-2 rounded-full bg-slate-50 px-3 py-1.5 text-sm text-slate-600">
          <Checkbox checked={done} onCheckedChange={() => onToggle(c.id)} data-testid={`journey-done-${c.id}`} /> I've finished this
        </label>
      </div>
      {c.description && <p className="mt-2 text-sm leading-relaxed text-slate-600">{c.description}</p>}
      <div className="mt-3 flex flex-wrap gap-x-5 gap-y-1 text-sm">
        {c.attendees && <span className="flex items-center gap-1.5 text-[#1D64B4]"><Users className="h-4 w-4" /> For: {c.attendees}</span>}
        <span className="flex items-center gap-1.5 text-slate-500"><Ticket className="h-4 w-4" /> Registration fee: {feeLabel(c.fee)}</span>
      </div>
      <div className="mt-4 space-y-2">
        {c.schedules.length === 0 && <p className="text-sm text-slate-400">New schedules coming soon.</p>}
        {c.schedules.map((s) => (
          <div key={s.id} className="flex flex-wrap items-center justify-between gap-3 rounded-2xl bg-[#F8FAFC] p-3 sm:p-4" data-testid={`journey-schedule-${s.id}`}>
            <div className="text-sm">
              <p className="flex items-center gap-1.5 font-medium text-slate-900"><CalendarDays className="h-4 w-4 text-[#1D64B4]" />{scheduleWhen(s)}</p>
              {s.venue && <p className="mt-0.5 flex items-center gap-1.5 text-slate-500"><MapPin className="h-4 w-4" />{s.venue}</p>}
            </div>
            <Button size="sm" onClick={() => onRegister(c, s)} className="rounded-full bg-[#0A3A6B] px-5 hover:bg-[#1D64B4]" data-testid={`journey-register-${s.id}`}>Register</Button>
          </div>
        ))}
      </div>
    </div>
  </li>
);
